// Libs
import React, { Component } from 'react'
import { Col, Row } from '../../../../components/Elemental'

// CSS
import './styles.scss'

// Components/Containers
import Button from '../../../../components/Button'
import Modal from '../../../../components/Modal'

class SpCaseErrorMessage extends Component {

  render() {
    const { message, visible, handleClose } = this.props

    return (
      <Modal visible={visible} md='50%' lg='50%'>
        <div className="sp-case-page-confirm">
          <Row>
            <Col className="sp-case-page-confirm__text">
              <p className="sp-case-page-confirm__header">Atenção!</p>
              <p className="sp-case-page-confirm__checkout" dangerouslySetInnerHTML={{ __html: message }} />
            </Col>
          </Row>
          <Row>
            <Col md="100%">
              <Button gutterTop={20} onClick={() => handleClose()}>Fechar</Button>
            </Col>
          </Row>
        </div>
      </Modal>
    )
  }
}

export default SpCaseErrorMessage
